import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from "react-helmet";

import Localization from "../../../localization";
import Button from "../../../components/button";
import ModalCancel from "../../../components/modalCancel";
import IconClose from "../../../components/icons/close";
import IconArrow from "../../../components/icons/arrow";
import Step1Form from "./BookingSteps/Step1Form";
import Step2Form from "./BookingSteps/Step2Form";
import Step3Form from "./BookingSteps/Step3Form";
import Step4Form from "./BookingSteps/Step4Form";
import Step5Form from "./BookingSteps/Step5Form";
import Step6Form from "./BookingSteps/Step6Form";
import Step7Form from "./BookingSteps/Step7Form";
import Step8Form from "./BookingSteps/Step8Form";
import Step9Form from "./BookingSteps/Step9Form";
import Step10Form from "./BookingSteps/Step10Form";
import Progress from "../../../components/progress";
import { changeArtisticsBooking } from "../../../redux/actions/options";
import { addOpenCallApplications } from "../../../redux/actions/openCalls";

const TOTAL_STEPS = 8;

class Booking extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
            currentStep: 1,
            finished: false,
            cancelModalVisible: false,
        };

        this.stepRef = null;
        this.stepValues = [];

        this._validationForm = this._validationForm.bind(this);
        this._onPress = this._onPress.bind(this);
        this._showCancelModal = this._showCancelModal.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!this.props.isAdding && prevProps.isAdding) {
            if (this.props.error) {
                let message =
                    Localization[this.props.locale].artistic_booking.error;

                if (this.props.error.data && this.props.error.data.errors) {
                    Object.values(this.props.error.data.errors).forEach((item) =>
                        item.forEach((error) => {
                            message += "\n- " + error;
                        })
                    );
                }

                this.setState({
                    error: message,
                });
            } else {
                this.setState({
                    error: null,
                    finished: true,
                });
            }
        }
    }

    _renderOverlay() {
        const { isVisible } = this.props;

        let className = "z-20 fixed inset-0 bg-black transition duration-500";
        if (isVisible) {
            className += " opacity-60 pointer-events-auto";
        } else {
            className += " opacity-0 pointer-events-none";
        }

        return (
            <div className={className} onClick={this._showCancelModal}>
                <div className="absolute inset-0 bg-gray-500 opacity-75" />
            </div>
        );
    }

    _renderHeader() {
        return (
            <div className="flex mb-60">
                <p className="text-30 mr-30 font-judge font-bold">
                    {Localization[this.props.locale].artistic_booking.title}
                </p>
                <div className="flex-1" />
                <div className="w-50 xl:w-70">
                    <Button
                        icon={
                            <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-white text-blue" />
                        }
                        onClick={this._showCancelModal}
                        style={"w-50 xl:w-70"}
                    />
                </div>
            </div>
        );
    }

    _renderStep(step) {
        const { locale } = this.props;

        let values = null;
        if (this.stepValues.length > 0) values = this.stepValues[step - 1];

        if (this.state.finished)
            return (
                <div className="flex-1 relative">
                    <p className="font-bold text-20 xl:text-30 text-blue mb-40">
                        {Localization[locale].artistic_booking.success}
                    </p>
                    <div className="flex">
                        <Button
                            text={
                                Localization[locale].artistic_booking
                                    .success_button
                            }
                            textStyle={
                                "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-blue"
                            }
                            backgroundColor={"bg-grey"}
                            onClick={this._showCancelModal}
                            wrapperStyle={"px-20"}
                        />
                    </div>
                </div>
            );

        switch (step) {
            case 1:
                return (
                    <Step1Form
                        values={values}
                        myRef={(ref) => (this.stepRef = ref)}
                    />
                );
            case 2:
                return (
                    <Step3Form
                        values={values}
                        myRef={(ref) => (this.stepRef = ref)}
                    />
                );
            case 3:
                return (
                    <Step4Form
                        values={values}
                        myRef={(ref) => (this.stepRef = ref)}
                    />
                );
            case 4:
                return (
                    <Step5Form
                        values={values}
                        myRef={(ref) => (this.stepRef = ref)}
                    />
                );
            case 5:
                return (
                    <Step6Form
                        values={values}
                        myRef={(ref) => (this.stepRef = ref)}
                    />
                );
            case 6:
                return (
                    <Step7Form
                        values={values}
                        myRef={(ref) => (this.stepRef = ref)}
                    />
                );
            case 7:
                return (
                    <Step8Form
                        values={values}
                        myRef={(ref) => (this.stepRef = ref)}
                    />
                );
            case 8:
                return (
                    <Step9Form
                        values={values}
                        myRef={(ref) => (this.stepRef = ref)}
                    />
                );
        }
    }

    _showCancelModal() {
        if (this.state.finished) {
            this._onPress();
            return;
        }

        this.setState({
            cancelModalVisible: true,
        });
    }

    _renderProgress(step, percentage) {
        const { locale } = this.props;

        if (this.state.finished) return null;

        return (
            <div className="flex h-46 items-center mt-20">
                <Progress locale={this.props.locale} percentage={percentage} />
                <div className="flex">
                    {step > 1 && (
                        <Button
                            icon={
                                <IconArrow
                                    className={
                                        "w-26 h-26 z-10 transition hover-hover:group-hover:text-white text-blue transform -rotate-90"
                                    }
                                />
                            }
                            backgroundColor={"bg-grey"}
                            onClick={() => {
                                this.setState({
                                    error: null,
                                    currentStep: step - 1,
                                });
                            }}
                            style="mr-10"
                            wrapperStyle="px-20"
                        />
                    )}
                    {step < TOTAL_STEPS && (
                        <Button
                            icon={
                                <IconArrow
                                    className={
                                        "w-26 h-26 z-10 transition hover-hover:group-hover:text-white text-blue transform rotate-90"
                                    }
                                />
                            }
                            backgroundColor={"bg-grey"}
                            onClick={() => {
                                this._validationForm(step);
                            }}
                            wrapperStyle={"px-20"}
                        />
                    )}
                    {step === TOTAL_STEPS && (
                        <Button
                            text={Localization[locale].artistic_booking.submit}
                            textStyle={
                                "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-blue"
                            }
                            backgroundColor={"bg-grey"}
                            onClick={() => {
                                this._validationForm(step);
                            }}
                            wrapperStyle={"px-20"}
                            isLoading={this.props.isAdding}
                        />
                    )}
                </div>
            </div>
        );
    }

    _validationForm(step) {
        if (this.stepRef.current) {
            this.stepRef.current.validateForm().then((e) => {
                this.stepRef.current.setTouched(e);

                if (this.stepRef.current.isValid) {
                    if (this.stepValues.length > step - 1) {
                        this.stepValues[step - 1] = this.stepRef.current.values;
                    } else {
                        this.stepValues.push(this.stepRef.current.values);
                    }

                    if (step === TOTAL_STEPS) {
                        let data = {
                            artist_email: this.stepValues[0].artist_email,
                            artist_phone: this.stepValues[0].artist_phone,
                            artist_name: this.stepValues[0].artist_name,
                            artist_type: this.stepValues[0].artist_type,

                            artist_address: this.stepValues[1].artist_address,
                            artist_postal_code:
                                this.stepValues[1].artist_postal_code,
                            artist_city: this.stepValues[1].artist_city,
                            artist_district: this.stepValues[1].artist_district,
                            artist_country: this.stepValues[1].artist_country,
                            artist_nif: this.stepValues[1].artist_nif,
                            artist_nationality:
                                this.stepValues[1].artist_nationality,
                            artist_tax_proof:
                                this.stepValues[1].artist_tax_proof,

                            artist_website: this.stepValues[2].artist_website,
                            artist_facebook: this.stepValues[2].artist_facebook,
                            artist_instagram:
                                this.stepValues[2].artist_instagram,
                            artist_vimeo: this.stepValues[2].artist_vimeo,
                            artist_youtube: this.stepValues[2].artist_youtube,

                            title: this.stepValues[3].title,
                            pitch: this.stepValues[3].pitch,
                            cover: this.stepValues[3].cover,
                            area: this.stepValues[3].area,

                            work_type: this.stepValues[4].work_type,
                            synopsis: this.stepValues[4].synopsis,
                            description: this.stepValues[4].description,
                            schedule: this.stepValues[4].schedule,

                            biography: this.stepValues[5].biography,
                            has_more_financing:
                                this.stepValues[5].has_more_financing,
                            financing: this.stepValues[5].financing,
                            video_links: this.stepValues[5].video_links,

                            team_elements: this.stepValues[6].team_elements,
                            hosting: this.stepValues[6].hosting,
                            reduced_mobility_team:
                                this.stepValues[6].reduced_mobility_team,

                            possible_dates: this.stepValues[7].possible_dates,
                            externals: this.stepValues[7].dramaturgists,
                            others: this.stepValues[7].others,
                        };

                        const openCall = this.props.openCallsData.find(
                            (item) => item.type === "artistic"
                        );

                        this.props.addOpenCallApplications(openCall.id, data);
                    } else {
                        this.setState({
                            error: null,
                            currentStep: step + 1,
                        });
                    }
                }
            });
        }
    }

    _onPress() {
        this.stepValues = [];

        setTimeout(() => {
            this.setState({
                error: null,
                currentStep: 1,
                finished: false,
            });
        }, 1000);

        this.props.changeArtisticsBooking(false);
    }

    render() {
        const { currentStep, cancelModalVisible } = this.state;
        const { isVisible, locale } = this.props;

        let className =
            "fixed bottom-0 top-0 left-0 flex justify-end right-0 transition duration-700 ease-in-out transform z-20";

        if (!isVisible) {
            className += " " + "translate-x-full";
        }

        let step = parseInt(currentStep);
        step = step ? step : 1;

        const percentage = Math.round(((step - 1) / TOTAL_STEPS) * 100);

        return (
            <div>
                <Helmet>{isVisible && <body className="modal-open" />}</Helmet>
                {this._renderOverlay()}
                <div className={className}>
                    <div onClick={this._showCancelModal} className="xl:w-1/2" />
                    <div className="flex flex-col w-full xl:w-1/2 px-16 xl:px-50 pt-30 xl:pt-40 pb-30 xl:pb-40 bg-grey">
                        {this._renderHeader()}
                        <div className="flex-1 overflow-y-auto">
                            {this._renderStep(step)}
                        </div>
                        {this.state.error && (
                            <p className="text-12 text-red mt-6 whitespace-pre-wrap">
                                {this.state.error}
                            </p>
                        )}
                        {this._renderProgress(step, percentage)}
                    </div>
                </div>
                <ModalCancel
                    visible={cancelModalVisible}
                    data={true}
                    title={Localization[locale].artistic_booking.cancel_title}
                    text={Localization[locale].artistic_booking.cancel_text}
                    onClose={(cancel) => {
                        if (cancel) this._onPress();

                        this.setState({
                            cancelModalVisible: false,
                        });
                    }}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    isVisible: state.options.isArtisticsBookingVisible,
    openCallsData: state.openCalls.data,
    isAdding: state.openCalls.isAdding,
    error: state.openCalls.errorMessage,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            addOpenCallApplications,
            changeArtisticsBooking,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Booking);
